export default {
  IS_CHANGE_STATUS: false
}



// WEBPACK FOOTER //
// ./src/util/call/klCnsAPI/ktCommon.js